import { LearningPath } from "./pages/learning-path/learning-path.component";

export const routes = [
  {
    path: "/learningPath",
    Component: LearningPath,
    exact: true,
    isPrivate: true,
  },
  {
    path: "/learningPath/:courseId",
    Component: LearningPath,
    exact: true,
    isPrivate: true,
  },
];
